import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { PaginationFilterDto } from "../../../types/Pagination";
import { useQuery } from "@tanstack/react-query";
import { getSurveyImportDetails } from "../api/surveyImportAPI";
import { ApiErrorResponse } from "../../../types/ApiErrorResponse";
import { SurveyImportDetailDto } from "../types";


type UseGetDetailSurveyLoads = {
    surveyImportId: string;
};

export const useGetSurveyImportDetails = ({
    surveyImportId
}: UseGetDetailSurveyLoads) => {

    const selectedFilters = useSelector(
        (state: RootState) => state.filters.detailSurveyLoads.selectedFilters
    );

    const pagination = useSelector(
        (state: RootState) => state.historical.detailSurveyLoads
    );

    const paginationFilters: PaginationFilterDto = {
        pageNumber: pagination.currentPage,
        pageSize: pagination.itemsPerPage,
        search: pagination.searchText,
        filters: selectedFilters,
        selectedOrganizationalStructureIds: []
    };

    return useQuery<
        SurveyImportDetailDto,
        ApiErrorResponse
    >({
        queryKey: [
            'getSurveyImportDetails',
            surveyImportId,
            selectedFilters,
            pagination
        ],
        queryFn: () => getSurveyImportDetails(surveyImportId, paginationFilters),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false
    });
};